import { FAREFORECASTER_UPDATE_FORM } from "src/redux/actions/fareForecaster";
import { FareForecasterFormDataI } from "src/types/FareForecaster";

const initialState: FareForecasterFormDataI = {
  preferredAirlines: [],
  numberOfStops: null,
  isRoundTrip: false,
  departureTime: null,
  travelClass: null,
};

export type FareForecasterAction = {
  type: typeof FAREFORECASTER_UPDATE_FORM;
  id: string;
  payload: FareForecasterFormDataI;
};

const fareForecaster = (
  state: FareForecasterFormDataI = initialState,
  action: FareForecasterAction,
) => {
  switch (action.type) {
    case FAREFORECASTER_UPDATE_FORM: {
      const newState = { ...state };
      const newForm = { ...newState[action.id], ...action.payload };
      newState[action.id] = newForm;
      return newState;
    }
    default:
      return state;
  }
};

export default fareForecaster;
